import React from 'react';

import block from 'propmods';

import { MarketDevice } from '../../model/devices';

import './DeviceLinkingSuggestCard.scss';

const b = block('DeviceLinkingSuggestCard');

interface Props {
    device: MarketDevice;
}

export const DeviceLinkingSuggestCard: React.FC<Props> = ({ device }) => {
    const { picture, title } = device;

    return (
        <div {...b()}>
            <div {...b('logo-frame')}>
                <div {...b('logo')}>
                    <img src={picture} {...b('image')} />
                </div>
            </div>
            <div {...b('content')}>
                <span {...b('title')}>{title}</span>
            </div>
        </div>
    );
};
